import React from 'react'

const SupplierManagement = () => {
  return (
    <div className='mx-auto p-4'>
      SupplierManagement
    </div>
  )
}

export default SupplierManagement
